<template>
  <div class="table-container">
    <!-- 搜索栏（固定） -->
    <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
      <!-- 电脑端使用 Element UI 搜索框 -->
      <div v-if="isDesktop" class="desktop-search-wrapper">
        <!-- TODO:不能有变动 -->
        <div class="search-row">
          <el-input 
            v-model="searchKeyword" 
            placeholder="请输入关键词搜索" 
            clearable
            size="small"
            class="search-input"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <div class="button-group">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="handleAdd"
              class="add-button"
            >
              添加
            </el-button>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-filter" 
              @click="toggleFilter"
              class="filter-button"
            >
              {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
            </el-button>
          </div>
        </div>
        
        <!-- 电脑端筛选面板 -->
        <div v-if="isFilterOpen" class="filter-panel">
          <div class="filter-row">
            <div class="filter-item">
              <label>类别：</label>
              <el-select v-model="filterForm.category" placeholder="请选择类别" clearable size="small" style="width: 150px;">
                <el-option label="电子产品" value="电子产品"></el-option>
                <el-option label="家居用品" value="家居用品"></el-option>
                <el-option label="办公用品" value="办公用品"></el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>状态：</label>
              <el-select v-model="filterForm.status" placeholder="请选择状态" clearable size="small" style="width: 120px;">
                <el-option label="激活" value="active"></el-option>
                <el-option label="停用" value="inactive"></el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>价格范围：</label>
              <el-input-number 
                v-model="filterForm.minPrice" 
                :min="0" 
                :step="100" 
                size="small" 
                placeholder="最小值" 
                style="width: 100px; margin-right: 10px;"
              ></el-input-number>
              <span style="margin: 0 10px;">-</span>
              <el-input-number 
                v-model="filterForm.maxPrice" 
                :min="0" 
                :step="100" 
                size="small" 
                placeholder="最大值" 
                style="width: 100px;"
              ></el-input-number>
            </div>
          </div>
          <div class="filter-actions">
            <div class="applied-filters">
              <span v-if="appliedFilterForm.category" class="filter-tag">
                类别: {{ appliedFilterForm.category }}
              </span>
              <span v-if="appliedFilterForm.status" class="filter-tag">
                状态: {{ appliedFilterForm.status === 'active' ? '激活' : '停用' }}
              </span>
              <span v-if="appliedFilterForm.minPrice || appliedFilterForm.maxPrice" class="filter-tag">
                价格: {{ appliedFilterForm.minPrice || 0 }}-{{ appliedFilterForm.maxPrice || '∞' }}
              </span>
              <span v-if="!appliedFilterForm.category && !appliedFilterForm.status && !appliedFilterForm.minPrice && !appliedFilterForm.maxPrice" class="filter-tag filter-tag-empty">
                当前无筛选条件
              </span>
            </div>
            <div class="filter-buttons">
              <el-button size="small" @click="resetFilter">重置筛选</el-button>
              <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 手机端使用 Vant 搜索框 -->
      <div v-else class="mobile-search-wrapper">
        <van-search
          v-model="searchKeyword"
          placeholder="请输入关键词搜索"
          show-action
          @search="handleSearch"
          @cancel="onSearchCancel"
          :placeholder-style="{ fontSize: '16px' }"
          :input-align="'center'"
        >
          <template #action>
            <div @click="handleSearch" style="margin-right: 10px; font-size: 16px; color: var(--primary); font-weight: 600;">搜索</div>
          </template>
        </van-search>
        
        <!-- 手机端添加按钮 -->
        <div class="mobile-add-button">
          <van-button 
            type="primary" 
            size="small" 
            block
            icon="plus"
            @click="handleAdd"
            style="margin-top: 10px;"
          >
            添加
          </van-button>
        </div>
        
        <!-- 手机端筛选面板 -->
        <div v-if="isFilterOpen" class="mobile-filter-panel">
          <!-- 手机端已应用筛选条件显示 -->
          <div class="mobile-applied-filters">
            <div v-if="appliedFilterForm.category || appliedFilterForm.status || appliedFilterForm.minPrice || appliedFilterForm.maxPrice" class="applied-title">已应用筛选条件：</div>
            <div class="applied-tags">
              <span v-if="appliedFilterForm.category" class="mobile-filter-tag">
                类别: {{ appliedFilterForm.category }}
              </span>
              <span v-if="appliedFilterForm.status" class="mobile-filter-tag">
                状态: {{ appliedFilterForm.status === 'active' ? '激活' : '停用' }}
              </span>
              <span v-if="appliedFilterForm.minPrice || appliedFilterForm.maxPrice" class="mobile-filter-tag">
                价格: {{ appliedFilterForm.minPrice || 0 }}-{{ appliedFilterForm.maxPrice || '∞' }}
              </span>
              <span v-if="!appliedFilterForm.category && !appliedFilterForm.status && !appliedFilterForm.minPrice && !appliedFilterForm.maxPrice" class="mobile-filter-tag empty">
                当前无筛选条件
              </span>
            </div>
          </div>
          
          <van-cell title="类别" is-link @click="showCategoryPicker = true">{{ filterForm.category || '全部' }}</van-cell>
          <van-cell title="状态" is-link @click="showStatusPicker = true">{{ filterForm.status ? (filterForm.status === 'active' ? '激活' : '停用') : '全部' }}</van-cell>
          <div class="price-range-filter">
            <div class="filter-label">价格范围</div>
            <div class="price-inputs">
              <el-input-number 
                v-model="filterForm.minPrice" 
                :min="0" 
                :step="100" 
                size="small" 
                placeholder="最小值" 
                style="width: 45%; margin-right: 10%;"
              ></el-input-number>
              <el-input-number 
                v-model="filterForm.maxPrice" 
                :min="0" 
                :step="100" 
                size="small" 
                placeholder="最大值" 
                style="width: 45%;"
              ></el-input-number>
            </div>
          </div>
          <div class="mobile-filter-actions">
            <van-button type="default" size="small" @click="resetFilter">重置</van-button>
            <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
          </div>
        </div>
        
        <!-- 手机端筛选展开按钮 -->
        <div class="mobile-filter-toggle" @click="toggleFilter">
          <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" /> 
          <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      <!-- 电脑端表格 -->
      <div class="table-wrapper" v-if="isDesktop">
        <el-table 
          :data="filteredData" 
          style="width: 100%" 
          class="desktop-table"
          :height="tableHeight"
        >
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="名称" width="180"></el-table-column>
        <el-table-column prop="category" label="类别" width="120"></el-table-column>
        <el-table-column prop="price" label="价格" width="100">
          <template slot-scope="scope">
            ¥{{ scope.row.price.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'danger'">
              {{ scope.row.status === 'active' ? '激活' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="155" fixed="right">
          <template slot-scope="scope">
            <div class="table-actions">
              <el-link @click="handleEdit(scope.row)" ><i class="el-icon-edit"></i>编辑</el-link>
              <el-dropdown @command="command($event,scope.row)">
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="remove" >删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      
      <!-- 手机端卡片 -->
      <div v-else class="mobile-cards">
        <div 
          v-for="item in filteredData" 
          :key="item.id" 
          class="mobile-card"
        >
          <div class="card-header">
            <h3>{{ item.name }}</h3>
            <el-tag :type="item.status === 'active' ? 'success' : 'danger'" size="small">
              {{ item.status === 'active' ? '激活' : '停用' }}
            </el-tag>
          </div>
          <div class="card-content">
            <p><strong>ID:</strong> {{ item.id }}</p>
            <p><strong>类别:</strong> {{ item.category }}</p>
            <p><strong>价格:</strong> ¥{{ item.price.toFixed(2) }}</p>
            <p><strong>创建时间:</strong> {{ item.createTime }}</p>
          </div>
          <div class="card-actions">
            <van-button 
              type="primary" 
              size="small" 
              plain
              icon="edit"
              @click="handleEdit(item)"
              style="margin-right: 10px;"
            >
              编辑
            </van-button>
            <van-button 
              type="default" 
              size="small" 
              plain
              icon="ellipsis"
              @click="showMoreActions(item)"
            >
              更多操作
            </van-button>
          </div>
        </div>
        
        <!-- 手机端操作菜单，只显示一次 -->
        <van-action-sheet
          v-model="showActionSheet"
          :actions="actionSheetActions"
          @select="onActionSheetSelect"
          @close="onActionSheetClose"
        />
      </div>
    </div>
    
    <!-- 分页（固定） -->
    <div class="pagination-container">
      <el-pagination
        v-if="isDesktop"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="filteredData.length"
      ></el-pagination>
      
      <el-pagination
        v-else
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15]"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="filteredData.length"
        small
      ></el-pagination>
    </div>
    
    <!-- 手机端选择器弹窗 -->
    <van-popup v-model="showCategoryPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="categoryColumns"
        @confirm="onCategoryConfirm"
        @cancel="showCategoryPicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showStatusPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="statusColumns"
        @confirm="onStatusConfirm"
        @cancel="showStatusPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
// 静态导入 Vant 弹框组件
import { Dialog, Toast } from 'vant'

export default {
  name: 'ExampleTable',
  data() {
    return {
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      isDesktop: true,
      // 筛选相关
      isFilterOpen: false,
      filterForm: {
        category: '',
        status: '',
        minPrice: null,
        maxPrice: null
      },
      // 保存已应用的筛选条件
      appliedFilterForm: {
        category: '',
        status: '',
        minPrice: null,
        maxPrice: null
      },
      // 手机端选择器
      showCategoryPicker: false,
      showStatusPicker: false,
      categoryColumns: ['全部', '电子产品', '家居用品', '办公用品'],
      statusColumns: ['全部', '激活', '停用'],
      // 手机端操作菜单
      showActionSheet: false,
      currentRow: null,
      actionSheetActions: [
        { name: '删除', type: 'danger' }
      ],
      // 表格数据
      tableData: [
        { id: 1, name: '产品A', category: '电子产品', price: 1999.00, status: 'active', createTime: '2024-01-01' },
        { id: 2, name: '产品B', category: '家居用品', price: 299.00, status: 'active', createTime: '2024-01-02' },
        { id: 3, name: '产品C', category: '办公用品', price: 49.90, status: 'inactive', createTime: '2024-01-03' },
        { id: 4, name: '产品D', category: '电子产品', price: 899.00, status: 'active', createTime: '2024-01-04' },
        { id: 5, name: '产品E', category: '家居用品', price: 199.00, status: 'inactive', createTime: '2024-01-05' },
        { id: 6, name: '产品F', category: '办公用品', price: 29.90, status: 'active', createTime: '2024-01-06' },
        { id: 7, name: '产品G', category: '电子产品', price: 1299.00, status: 'active', createTime: '2024-01-07' },
        { id: 8, name: '产品H', category: '家居用品', price: 399.00, status: 'active', createTime: '2024-01-08' },
        { id: 9, name: '产品I', category: '办公用品', price: 59.90, status: 'inactive', createTime: '2024-01-09' },
        { id: 10, name: '产品J', category: '电子产品', price: 799.00, status: 'active', createTime: '2024-01-10' },
        { id: 11, name: '产品K', category: '家居用品', price: 149.00, status: 'active', createTime: '2024-01-11' },
        { id: 12, name: '产品L', category: '办公用品', price: 19.90, status: 'active', createTime: '2024-01-12' }
      ]
    }
  },
  computed: {
    filteredData() {
      return this.tableData.filter(item => {
        // 关键词搜索
        const keyword = this.searchKeyword.toLowerCase()
        const matchesKeyword = !keyword || 
                             item.name.toLowerCase().includes(keyword) ||
                             item.category.toLowerCase().includes(keyword) ||
                             item.id.toString().includes(keyword)
        
        // 类别筛选
        const matchesCategory = !this.filterForm.category || item.category === this.filterForm.category
        
        // 状态筛选
        const matchesStatus = !this.filterForm.status || item.status === this.filterForm.status
        
        // 价格范围筛选
        const matchesPrice = 
          (!this.filterForm.minPrice || item.price >= this.filterForm.minPrice) &&
          (!this.filterForm.maxPrice || item.price <= this.filterForm.maxPrice)
        
        return matchesKeyword && matchesCategory && matchesStatus && matchesPrice
      })
    },
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 180 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 100 // 100是其他元素的额外高度
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    // 初始化时，将当前筛选条件设为已应用条件
    this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.checkScreenSize()
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    handleSearch() {
      this.currentPage = 1
    },
    // 处理添加按钮点击
    handleAdd() {
      // 这里可以添加添加功能的逻辑，例如打开添加弹窗或跳转到添加页面
      this.$message({
        message: '添加功能被触发',
        type: 'success'
      })
      // 实际项目中可以使用：
      // this.$router.push('/add') 或打开添加弹窗
    },
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    // 应用筛选
    applyFilter() {
      // 保存当前筛选条件为已应用条件
      this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
      this.currentPage = 1
    },
    // 重置筛选
    resetFilter() {
      // 初始化筛选条件
      const initialFilter = {
        category: '',
        status: '',
        minPrice: null,
        maxPrice: null
      }
      // 同时重置当前筛选表单和已应用筛选条件
      this.filterForm = JSON.parse(JSON.stringify(initialFilter))
      this.appliedFilterForm = JSON.parse(JSON.stringify(initialFilter))
      this.currentPage = 1
    },
    // 手机端类别选择确认
    onCategoryConfirm(value) {
      this.filterForm.category = value === '全部' ? '' : value
      this.showCategoryPicker = false
      this.applyFilter()
    },
    // 手机端状态选择确认
    onStatusConfirm(value) {
      this.filterForm.status = value === '全部' ? '' : (value === '激活' ? 'active' : 'inactive')
      this.showStatusPicker = false
      this.applyFilter()
    },
    handleEdit(row) {
      if (this.isDesktop) {
        // 电脑端使用 Element UI message
        this.$message(`编辑：${row.name}`)
      } else {
        // 手机端使用 Vant Toast
        Toast({
          message: `编辑：${row.name}`,
          duration: 2000
        })
      }
    },
    handleDelete(row) {
      if (this.isDesktop) {
        // 电脑端使用 Element UI 弹框
        this.$confirm(`确定要删除 ${row.name} 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData = this.tableData.filter(item => item.id !== row.id)
          this.$message({
            type: 'success',
            message: '删除成功'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        // 手机端使用 Vant Dialog
        Dialog.confirm({
          title: '提示',
          message: `确定要删除 ${row.name} 吗？`,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        .then(() => {
          // 确认删除
          this.tableData = this.tableData.filter(item => item.id !== row.id)
          Toast({
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
        .catch(() => {
          // 取消删除
          Toast({
            message: '已取消删除',
            type: 'info',
            duration: 2000
          })
        })
      }
    },
    // 处理更多操作命令
    command(cmd, row) {
      if (cmd === 'remove') {
        this.handleDelete(row)
      }
    },
    // 显示手机端更多操作菜单
    showMoreActions(row) {
      this.currentRow = row
      this.showActionSheet = true
    },
    // 处理手机端操作菜单选择
    onActionSheetSelect(action, index) {
      if (action.name === '删除') {
        this.handleDelete(this.currentRow)
      }
      this.showActionSheet = false
    },
    // 关闭手机端操作菜单
    onActionSheetClose() {
      this.currentRow = null
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    // 处理 Vant 搜索框取消事件
    onSearchCancel() {
      this.searchKeyword = ''
    }
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.search-container h2 {
  margin-bottom: 20px;
  color: var(--text);
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

/* 手机端添加按钮样式 */
.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

.mobile-search-container {
  margin-bottom: 15px;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
}

.price-range-filter {
  padding: 15px;
  border-bottom: 1px solid var(--border-light);
}

.filter-label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
  margin-bottom: 10px;
}

.price-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
}

/* 电脑端表格 */
.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  /* border: 1px solid var(--border); */
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions{
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-header h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.6;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 60px;
  text-align: left;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

/* Vant按钮样式优化 */
.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

/* Vant下拉菜单样式优化 */
.card-actions .van-dropdown-menu {
  font-size: 13px;
  flex-shrink: 0;
}

/* 适配小屏幕，确保操作按钮不会换行 */
@media (max-width: 375px) {
  .card-actions {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  
  .card-actions .van-button {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
  
  .card-actions .van-dropdown-menu {
    width: 100%;
  }
}

/* 分页（固定） */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-container h2 {
    margin-bottom: 15px;
  }
  
  .search-container .search-input {
    display: none;
  }
  
  .content-container {
    padding: 10px 0;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .pagination-container {
    text-align: center;
    padding: 15px;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-select,
  .filter-item .el-input-number {
    width: 100% !important;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }
  
  .desktop-table {
    display: block;
  }
  
  .mobile-cards {
    display: none;
  }
}

@media (max-width: 768px) {
  .search-container{
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }
  .van-search{
    padding:0;
  }
  .desktop-table {
    display: none;
  }
  
  .mobile-cards {
    display: flex;
  }
  
  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-input {
    max-width: 100%;
  }
}
</style>